export interface VideoItem {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  duration: string;
  views: number;
  date: string;
  featured: boolean;
}

export const categories = [
  { slug: 'all', name: '全部视频', icon: 'ri-play-list-2-line', description: '浏览所有蘑菇视频教程', count: 24 },
  { slug: 'planting', name: '种植全流程', icon: 'ri-seedling-line', description: '从菌种培育到出菇全过程', count: 6 },
  { slug: 'display', name: '成品展示', icon: 'ri-image-line', description: '蘑菇成品精美展示视频', count: 5 },
  { slug: 'cultivation', name: '人工培育', icon: 'ri-user-heart-line', description: '人工操作技巧详解', count: 5 },
  { slug: 'making', name: '制作技巧', icon: 'ri-tools-line', description: '蘑菇成品制作方法', count: 4 },
  { slug: 'harvest', name: '采收技术', icon: 'ri-scissors-cut-line', description: '科学采收与保鲜', count: 4 },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '香菇菌棒制作全流程详解',
    description: '从配料、装袋到灭菌接种，完整展示香菇菌棒制作每一步操作技巧，适合初学者入门学习。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Shiitake%20mushroom%20spawn%20bags%20on%20wooden%20shelves%20in%20a%20clean%20cultivation%20room%2C%20warm%20natural%20lighting%2C%20professional%20mushroom%20farm%20setting%2C%20detailed%20texture%20of%20substrate%20bags%2C%20earthy%20tones%2C%20documentary%20style%20photography&width=640&height=360&seq=mushroom-v1&orientation=landscape',
    category: 'planting',
    duration: '18:24',
    views: 32680,
    date: '2026-07-15',
    featured: true,
  },
  {
    id: 'v2',
    title: '平菇出菇管理关键期操作',
    description: '平菇出菇期的温度、湿度、通风三大要素精准控制技巧，确保高产优质出菇效果。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Oyster%20mushrooms%20growing%20beautifully%20on%20vertical%20substrate%20columns%20in%20a%20climate%20controlled%20grow%20room%2C%20soft%20diffused%20light%2C%20delicate%20grey%20brown%20mushroom%20caps%2C%20professional%20indoor%20farm%2C%20clean%20white%20walls%2C%20natural%20organic%20feel&width=640&height=360&seq=mushroom-v2&orientation=landscape',
    category: 'planting',
    duration: '22:10',
    views: 25140,
    date: '2026-07-12',
    featured: true,
  },
  {
    id: 'v3',
    title: '金针菇工厂化瓶栽技术展示',
    description: '走进现代化金针菇工厂，见证从接种到采收的全自动化瓶栽生产流程，震撼的规模化种植场景。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Enoki%20mushrooms%20growing%20in%20glass%20bottles%20in%20a%20modern%20automated%20factory%2C%20rows%20of%20tall%20white%20slender%20mushrooms%2C%20clean%20industrial%20setting%20with%20LED%20lighting%2C%20precise%20humidity%20control%2C%20impressive%20scale%2C%20professional%20food%20production&width=640&height=360&seq=mushroom-v3&orientation=landscape',
    category: 'display',
    duration: '15:08',
    views: 41920,
    date: '2026-07-10',
    featured: true,
  },
  {
    id: 'v4',
    title: '灵芝人工栽培技术完整教程',
    description: '灵芝从母种扩繁到子实体培育的完整周期，详细讲解灵芝生长各阶段的环境要求与管理要点。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ganoderma%20lucidum%20reishi%20mushrooms%20with%20glossy%20red%20brown%20caps%20growing%20on%20wood%20logs%20in%20a%20greenhouse%2C%20warm%20natural%20light%20through%20glass%2C%20lush%20green%20background%2C%20healthy%20vibrant%20specimens%2C%20herbal%20medicine%20cultivation&width=640&height=360&seq=mushroom-v4&orientation=landscape',
    category: 'cultivation',
    duration: '28:45',
    views: 18760,
    date: '2026-07-08',
    featured: false,
  },
  {
    id: 'v5',
    title: '蘑菇成品包装与保鲜技术',
    description: '采收后的蘑菇如何科学分级、包装、预冷和保鲜？本视频带你了解完整的采后处理流程。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Fresh%20mushrooms%20neatly%20packaged%20in%20eco%20friendly%20paper%20boxes%20on%20a%20clean%20packaging%20line%2C%20various%20mushroom%20varieties%2C%20professional%20food%20processing%20facility%2C%20bright%20clean%20lighting%2C%20natural%20organic%20produce%2C%20farm%20to%20table%20concept&width=640&height=360&seq=mushroom-v5&orientation=landscape',
    category: 'harvest',
    duration: '14:32',
    views: 15230,
    date: '2026-07-05',
    featured: false,
  },
  {
    id: 'v6',
    title: '秀珍菇立体栽培高产秘诀',
    description: '利用立体层架实现秀珍菇高密度种植，合理的空间利用与管理让产量翻倍。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Multi%20tier%20shelving%20system%20with%20rows%20of%20fresh%20mini%20oyster%20mushrooms%20in%20a%20greenhouse%2C%20efficient%20vertical%20farming%2C%20healthy%20white%20grey%20mushrooms%2C%20bright%20morning%20sunlight%2C%20sustainable%20agriculture%2C%20clean%20earthy%20atmosphere&width=640&height=360&seq=mushroom-v6&orientation=landscape',
    category: 'cultivation',
    duration: '20:18',
    views: 21340,
    date: '2026-07-03',
    featured: true,
  },
  {
    id: 'v7',
    title: '蘑菇干制品加工方法大全',
    description: '不同菇类的烘干、冻干及盐渍加工技术，延长产品保质期，提升附加值。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Assorted%20dried%20mushrooms%20displayed%20beautifully%20in%20glass%20jars%20and%20woven%20baskets%2C%20various%20colors%20and%20shapes%2C%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20artisanal%20food%20preservation%2C%20natural%20organic%20whole%20foods&width=640&height=360&seq=mushroom-v7&orientation=landscape',
    category: 'making',
    duration: '16:55',
    views: 12450,
    date: '2026-07-01',
    featured: false,
  },
  {
    id: 'v8',
    title: '黑木耳段木栽培传统工艺',
    description: '传承百年的黑木耳段木栽培技术，从选木、打孔、接种到出耳管理的全套传统工艺。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Black%20wood%20ear%20mushrooms%20growing%20on%20stacked%20logs%20in%20a%20shaded%20forest%20setting%2C%20traditional%20log%20cultivation%20method%2C%20dark%20rich%20mushrooms%20on%20wood%20bark%2C%20natural%20dappled%20sunlight%2C%20rustic%20outdoor%20mushroom%20farm&width=640&height=360&seq=mushroom-v8&orientation=landscape',
    category: 'planting',
    duration: '25:30',
    views: 19320,
    date: '2026-06-28',
    featured: false,
  },
  {
    id: 'v9',
    title: '杏鲍菇工厂化生产全流程',
    description: '从培养基配制、装瓶灭菌到接种培养，展示杏鲍菇工厂化生产线的每一个环节。',
    thumbnail: 'https://readdy.ai/api/search-image?query=King%20oyster%20mushrooms%20with%20thick%20white%20stems%20growing%20in%20neat%20rows%20inside%20a%20modern%20mushroom%20farm%2C%20controlled%20environment%2C%20large%20healthy%20specimens%2C%20bright%20clean%20industrial%20setting%2C%20precision%20agriculture%2C%20food%20production&width=640&height=360&seq=mushroom-v9&orientation=landscape',
    category: 'display',
    duration: '19:42',
    views: 28750,
    date: '2026-06-25',
    featured: true,
  },
  {
    id: 'v10',
    title: '蘑菇菌种分离与保藏技术',
    description: '组织分离法和孢子分离法的操作要点，以及菌种的短期与长期保藏方法详解。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mushroom%20mycelium%20growing%20in%20petri%20dishes%20on%20a%20sterile%20laboratory%20workbench%2C%20clean%20white%20lab%20setting%2C%20scientific%20equipment%2C%20pure%20culture%20technique%2C%20bright%20even%20lighting%2C%20professional%20biotechnology%20research&width=640&height=360&seq=mushroom-v10&orientation=landscape',
    category: 'cultivation',
    duration: '21:15',
    views: 16430,
    date: '2026-06-22',
    featured: false,
  },
  {
    id: 'v11',
    title: '蘑菇酱料制作家庭版教程',
    description: '用新鲜蘑菇自制美味蘑菇酱，无添加剂防腐剂，健康美味的餐桌伴侣。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Homemade%20mushroom%20sauce%20in%20a%20beautiful%20ceramic%20bowl%20surrounded%20by%20fresh%20mushrooms%20and%20herbs%20on%20a%20rustic%20wooden%20kitchen%20table%2C%20warm%20cozy%20lighting%2C%20artisanal%20cooking%2C%20rich%20earthy%20tones%2C%20food%20photography%20style&width=640&height=360&seq=mushroom-v11&orientation=landscape',
    category: 'making',
    duration: '11:38',
    views: 35420,
    date: '2026-06-20',
    featured: false,
  },
  {
    id: 'v12',
    title: '双孢蘑菇覆土管理技术',
    description: '双孢蘑菇覆土材料的选择、处理及覆土后的温湿度管理，决定产量和品质的关键环节。',
    thumbnail: 'https://readdy.ai/api/search-image?query=White%20button%20mushrooms%20emerging%20from%20dark%20rich%20casing%20soil%20in%20growing%20beds%2C%20indoor%20mushroom%20farm%2C%20neat%20rows%20of%20young%20mushrooms%2C%20soft%20overhead%20lighting%2C%20professional%20cultivation%2C%20clean%20organized%20facility&width=640&height=360&seq=mushroom-v12&orientation=landscape',
    category: 'planting',
    duration: '17:20',
    views: 14280,
    date: '2026-06-18',
    featured: false,
  },
];

export const getVideosByCategory = (categorySlug: string): VideoItem[] => {
  if (categorySlug === 'all') return videos;
  return videos.filter((v) => v.category === categorySlug);
};

export const getVideoById = (id: string): VideoItem | undefined => {
  return videos.find((v) => v.id === id);
};

export const getFeaturedVideos = (): VideoItem[] => {
  return videos.filter((v) => v.featured);
};

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  if (views >= 1000) {
    return `${(views / 1000).toFixed(1)}k`;
  }
  return String(views);
};